import React from 'react';

const ArrowDow = (props) => (
    <svg
        width="12"
        height="8"
        viewBox="0 0 12 8"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M12 1.70498L10.59 0.294983L6 4.87498L1.41 0.294983L0 1.70498L6 7.70498L12 1.70498Z"
            fill="currentColor"
        />
    </svg>
);

export default ArrowDow;
